// extracted by mini-css-extract-plugin
export default {"hidden":"Contacts_hidden__AF9ph","container":"Contacts_container__Q8w2L"};